import IconV2 from '@/components/v2/IconV2.jsx';
import Spinner from '@/components/Spinner.jsx';
import Button from './Button.jsx';
import Link from '@/components/Link.jsx';
import HelpIcon from './HelpIcon.jsx';

const EmptyStateNotice = ({ icon, title, bordered = false, description, loading = false, size = 'sm', iconSize, card = false, cardSm, className = '', actions = [], helpIconContext, bottom, content }) => {
  return (
    <div className={`comp-empty-state-notice size-${size} ${bordered ? 'bordered' : ''} ${card ? 'card' : ''} ${cardSm ? 'card-sm' : ''} ${className}`}>
      <div>
        {!loading && (
          <div className={'icon-wrapper'}>
            <IconV2 icon={icon} size={iconSize || (size === 'sm' ? 20 : 24)} />
          </div>
        )}
        {loading && <Spinner size={size === 'sm' ? 20 : 24} loading={true} />}

        {title && <div className={'empty-title'}>{title}</div>}
        {description && <div className={'empty-description'}>{description}</div>}
        {content && <div className={'empty-content'}>{content}</div>}
        {actions && actions?.length > 0 && (
          <div className={'empty-actions'}>
            {actions?.map((action, idx) => (
              <Link key={idx} to={action?.route}>
                <Button key={idx} icon={action.icon} iconPosition={action.iconPosition} className={action?.className} onClick={action.onClick} loading={action.loading} size={action.size} disabled={action.disabled} id={action?.id} options={action?.options} onOptionClick={action?.onOptionClick} data-title={action?.dataTitle}>
                  {action.label || ''}
                </Button>
              </Link>
            ))}
            {helpIconContext && <HelpIcon context={helpIconContext} />}
          </div>
        )}
        {bottom}
      </div>
    </div>
  );
};

export default EmptyStateNotice;
